define('shared/initializer/form/newHouseAdapters/mixins/Loginable',[
    'shared/lib/RSVP',
    'shared/remote/efid/login',
    'shared/my/accessToken',
    'shared/my/cmus',
    'shared/remote/member/get',
    'shared/remote/member/house',
    'shared/remote/account/current',
    'shared/page/partner',
    'shared/util/path',
    'shared/remote/efid/const',
    'shared/remote/efid/util',
    'shared/lib/URI',
    '../../adapters/Login'
], function(
    RSVP,
    loginEFID,
    accessToken,
    getCMus,
    getMember,
    getMemberHouse,
    getCurrentAcount,
    getPartner,
    path,
    efidConstants,
    efidUtil,
    URI,
    OldHouseLoginAdapter
){
    var PATH_OLD_HOUSE_REDIRECTION_DEFAULT = 
        '/school/course/currentcourse/handler.aspx?entry=true';
    var PATH_PARTNERS = {
        'webd': '/signup/profile/b2c'
    };
    
    function tryOldHouseRedirect() {
        return RSVP.resolve()
            .then(function(){
                return RSVP.all([getPartner(), getCMus()]);
            })
            .then(function(values){
                var partnerCode = values[0];
                var cmus = values[1];

                if(cmus == null && cmus.length <= 0) {
                    return;
                }

                if( partnerCode == null ) {
                    partnerCode = '';
                }

                partnerCode = partnerCode.toLowerCase();
                
                window.location.href = PATH_PARTNERS[partnerCode] || 
                    PATH_OLD_HOUSE_REDIRECTION_DEFAULT;
            });
    }

    function Ctor() { }

    Ctor.redirect = function(options) {
        return RSVP.resolve()
            .then(function(){
                return accessToken.get();
            })
            .then(function(accessToken){
                if (accessToken) {
                    var allowedKeys = {
                        'redirect_condition': true, 
                        'redirect_uri': true
                    };
                    var uri = new URI(window.location.href);
                    var quries = uri.query(true);
                    var quriesToPass = {};
                    
                    for(var key in quries) {
                        if (key in allowedKeys) {
                            quriesToPass[key] = quries[key];
                        }
                    }

                    uri.query(quriesToPass);
                    
                    return window.location = 
                        efidConstants.DEFAULT_REDIRECT + '?' + uri.query();
                }
                else {
                    if (options && options.doNotTryOldHouse) {
                        return;    
                    }
                    return tryOldHouseRedirect();
                }
            });
    };

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        return OldHouseLoginAdapter.setupLoginForm(me.$form);
    };

    Ctor.prototype.doSubmit = function() {
        var me = this;
        var $form = me.$form;
        var $psd = $form.find('[name="Password"]');
        var $usr = $form.find('[name="UserName"]');
        var email = $usr.val();
        var password = $psd.val();

        return RSVP.resolve()
            .then(function(){
                return getMemberHouse({
                    email: email
                });
            })
            .then(function(memberHouse){
                if (memberHouse === getMemberHouse.NOT_EXIST) {
                    throw new Error('User does not exist');
                }

                if (memberHouse === getMemberHouse.OLD) {
                    $form[0].submit();
                }
                else {
                    return loginEFID({
                            email: email,
                            password: password
                        })
                        .then(function(){
                            return Ctor.redirect();
                        });
                }
            })
            .then(null, function(err) {
                if (!err.type) {
                    err.type = 'generic';
                }
                err.fatal = false;
                return RSVP.reject(err);
            });
    };

    return Ctor;
});
